import MenuBreadcrumb from "../../../components/menus/m-breadcrumb";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
// import Figure from "react-bootstrap/Figure";
// import CommandeProduits from "../../../components/pages/ventes/c-cde-produits";
import PdfViewer from "../../../__utils/tools/pdf-viewer";
import pdfFile from "../../../assets/img/img-fromage/flyer-2026-paques.pdf";

const Ventes = () => {
  return (
    <main role="main" className="mc-fond-fromage">
      <Container fluid className="gx-0">
        <Row className="gx-0">
          <Col className="gx-0">
            {/***************************** menu breadcrumb */}
            <MenuBreadcrumb />
            {/************************** Partie Fromage */}
            <Card bg="transparent" className="m-2 border-0">
              <Card.Header className="mc-rampart mc-rfs-2 m-2 text-primary rounded-2 text-center bg-white">
                Vente de produits locaux
              </Card.Header>
              <Card.Body className="m-2 p-0">
                <Card.Text className="text-light lh-sm mc-rfs-3 p-5 text-center">
                  <p>
                    Pour les fêtes de Noël, participez à la vente de fromages,
                    charcuterie et vins provenant de producteurs reconnus à
                    présenter sur vos tables durant les repas de famille.
                  </p>
                  <p className="fst-italic mc-rfs-4">
                    Acheter les produits du TENNIS CLUB DE FEILLENS c'est
                    participer au développement du club, garantir un niveau
                    d'adhésion préférentiel et soutenir les animations proposées
                    par le club à ses adhérents et amis tout au long de l'année.
                    😀
                  </p>
                </Card.Text>
              </Card.Body>
            </Card>
            <Card className="bg-transparent flex-lg-row justify-content-between mx-2 mt-3 border-0">
              <Col lg={6}>
                <Card.Body className="m-2 rounded-3 border border-5 border-warning text-center text-light">
                  <PdfViewer
                    pdfFile={pdfFile}
                    pageNo={1}
                    toolTipText={"Télécharger le bon de commande"}
                  />
                </Card.Body>
              </Col>
              <Col lg={6}>
                <Card.Body className="m-2 rounded-3 border border-5 border-warning text-center text-light">
                  <PdfViewer
                    pdfFile={pdfFile}
                    pageNo={2}
                    toolTipText={"Télécharger le bon de commande"}
                  />
                </Card.Body>
              </Col>
            </Card>
          </Col>
        </Row>
      </Container>
    </main>
  );
};

export default Ventes;
